export default {
  inputPlaceholder: 'Search a city or address'
}